import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RedispatchFile } from '../../domain/model/redispatch-file';
import { map } from 'rxjs/operators';
import { FileSaverService } from '../common/file/file-saver.service';

@Injectable({
    providedIn: 'root',
})
export class BedienungsanleitungService {

    private readonly SERVICE_URL = `${environment.API_URL}/bedienungsanleitung`;
    private readonly SERVICE_URL_ADMIN = `${environment.API_URL}/admin/bedienungsanleitung`;

    private http = inject(HttpClient);
    private fileSaverService = inject(FileSaverService);

    public isAvailable(): Observable<RedispatchFile | null> {
        return this.http.get<RedispatchFile>(this.SERVICE_URL, { observe: 'response' }).pipe(
            map(value => {
                if (value.status == 200) {
                    return value.body;
                } else {
                    return null;
                }
            }),
        );
    }

    public download(): void {
        const req = new HttpRequest(
            'GET',
            `${this.SERVICE_URL}/bedienungsanleitung.pdf`,
            {
                headers: new HttpHeaders({
                    'Accept': 'application/pdf',
                }),
                reportProgress: true,
                responseType: 'blob',
            },
        );
        this.http.request<Blob>(req).subscribe(event => {
            if (event.type === HttpEventType.Response) {
                this.fileSaverService.saveFile(
                    BedienungsanleitungService.extractFileName(event.headers, 'TnbTdlBedienungsanleitung.pdf'),
                    event.body,
                );
            }
        });
    }

    public upload(file: File): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);

        const req = new HttpRequest(
            'POST',
            this.SERVICE_URL_ADMIN,
            formData,
        );
        return this.http.request(req);
    }

    public delete(): Observable<any> {
        return this.http.delete(this.SERVICE_URL_ADMIN) as Observable<any>;
    }

    private static extractFileName(headers: HttpHeaders, defaultName?: string): string {
        const contentDisposition = headers.get('Content-Disposition');
        const filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].replace(/"/g, '').trim();

        return filename !== null ? filename : defaultName;
    }
}
